/**
 * Generated from PostcardRio2Layout.fla
 */
export function PostcardRio2Layout(this: IPostcardRio2Layout) {
	const main = this.main;
	PostcardRio2Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardRio2Layout_main(this: IPostcardRio2Layout_main) {
	const postcard = this.postcard;
	PostcardRio2Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardRio2Layout_postcard(this: IPostcardRio2Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardRio2Layout_cardTransform1.call(cardTransform[0] as IPostcardRio2Layout_cardTransform1);
		cardTransform[0].x = -396.95;
		cardTransform[0].y = -366.85;
		cardTransform[0].width = 604.33;
		cardTransform[0].height = 757.51;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardRio2Layout_cardTransform2.call(cardTransform[1] as IPostcardRio2Layout_cardTransform2);
		cardTransform[1].x = 616.75;
		cardTransform[1].y = 318.05;
		cardTransform[1].width = 403.75;
		cardTransform[1].height = 506.09;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardRio2Layout_cardTransform3.call(cardTransform[2] as IPostcardRio2Layout_cardTransform3);
		cardTransform[2].x = -379.85;
		cardTransform[2].y = 324.45;
		cardTransform[2].width = 393.46;
		cardTransform[2].height = 493.06;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardRio2Layout_cardTransform4.call(cardTransform[3] as IPostcardRio2Layout_cardTransform4);
		cardTransform[3].x = -658.7;
		cardTransform[3].y = 304.65;
		cardTransform[3].width = 426.01;
		cardTransform[3].height = 533.99;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardRio2Layout_cardTransform5.call(cardTransform[4] as IPostcardRio2Layout_cardTransform5);
		cardTransform[4].x = 90.85;
		cardTransform[4].y = -150.8;
		cardTransform[4].width = 596.00;
		cardTransform[4].height = 747.06;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardRio2Layout_cardTransform6.call(cardTransform[5] as IPostcardRio2Layout_cardTransform6);
		cardTransform[5].x = 470.95;
		cardTransform[5].y = -431;
		cardTransform[5].width = 404.34;
		cardTransform[5].height = 506.82;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardRio2Layout_cardTransform7.call(cardTransform[6] as IPostcardRio2Layout_cardTransform7);
		cardTransform[6].x = -28.8;
		cardTransform[6].y = 20.7;
		cardTransform[6].width = 1535.87;
		cardTransform[6].height = 1925.17;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardRio2Layout_cardTransform8.call(cardTransform[7] as IPostcardRio2Layout_cardTransform8);
		cardTransform[7].x = 164.5;
		cardTransform[7].y = 406.75;
		cardTransform[7].width = 379.51;
		cardTransform[7].height = 475.71;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		PostcardRio2Layout_pieces7.call(items[0] as IPostcardRio2Layout_pieces7);
		items[0].x = -47.8;
		items[0].y = 16.8;
		items[0].width = 1542.00;
		items[0].height = 909.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardRio2Layout_outlines7.call(items[1] as IPostcardRio2Layout_outlines7);
		items[1].x = -15.75;
		items[1].y = -77.5;
		items[1].width = 998.00;
		items[1].height = 721.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[2]) {
		PostcardRio2Layout_pieces4.call(items[2] as IPostcardRio2Layout_pieces4);
		(items[2] as IPostcardRio2Layout_pieces4).dependsOn = 0;
		(items[2] as IPostcardRio2Layout_pieces4).outlineGlow = true;
		items[2].x = -657.95;
		items[2].y = 304.3;
		items[2].width = 289.00;
		items[2].height = 452.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardRio2Layout_outlines4.call(items[3] as IPostcardRio2Layout_outlines4);
		items[3].x = -657.45;
		items[3].y = 300.9;
		items[3].width = 289.00;
		items[3].height = 446.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[4]) {
		PostcardRio2Layout_pieces3.call(items[4] as IPostcardRio2Layout_pieces3);
		(items[4] as IPostcardRio2Layout_pieces3).dependsOn = 0;
		(items[4] as IPostcardRio2Layout_pieces3).outlineGlow = true;
		items[4].x = -371.6;
		items[4].y = 321.65;
		items[4].width = 227.00;
		items[4].height = 410.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardRio2Layout_outlines3.call(items[5] as IPostcardRio2Layout_outlines3);
		items[5].x = -372.35;
		items[5].y = 322.15;
		items[5].width = 227.00;
		items[5].height = 411.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[6]) {
		PostcardRio2Layout_pieces2.call(items[6] as IPostcardRio2Layout_pieces2);
		(items[6] as IPostcardRio2Layout_pieces2).dependsOn = 0;
		(items[6] as IPostcardRio2Layout_pieces2).outlineGlow = true;
		items[6].x = 617.35;
		items[6].y = 317.7;
		items[6].width = 301.99;
		items[6].height = 403.99;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardRio2Layout_outlines2.call(items[7] as IPostcardRio2Layout_outlines2);
		items[7].x = 617.35;
		items[7].y = 314.7;
		items[7].width = 302.00;
		items[7].height = 398.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[8]) {
		PostcardRio2Layout_pieces1.call(items[8] as IPostcardRio2Layout_pieces1);
		(items[8] as IPostcardRio2Layout_pieces1).dependsOn = 0;
		(items[8] as IPostcardRio2Layout_pieces1).outlineGlow = true;
		items[8].x = -401.75;
		items[8].y = -377.6;
		items[8].width = 475.00;
		items[8].height = 335.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardRio2Layout_outlines1.call(items[9] as IPostcardRio2Layout_outlines1);
		items[9].x = -401.75;
		items[9].y = -378.5;
		items[9].width = 476.00;
		items[9].height = 334.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[10]) {
		PostcardRio2Layout_pieces6.call(items[10] as IPostcardRio2Layout_pieces6);
		(items[10] as IPostcardRio2Layout_pieces6).dependsOn = 0;
		(items[10] as IPostcardRio2Layout_pieces6).outlineGlow = true;
		items[10].x = 478.9;
		items[10].y = -430.15;
		items[10].width = 256.00;
		items[10].height = 297.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"dependsOn":0,"outlineGlow":false});
	}
	if (items[11]) {
		PostcardRio2Layout_pieces5.call(items[11] as IPostcardRio2Layout_pieces5);
		(items[11] as IPostcardRio2Layout_pieces5).dependsOn = 0;
		(items[11] as IPostcardRio2Layout_pieces5).outlineGlow = false;
		items[11].x = 87.25;
		items[11].y = -143.7;
		items[11].width = 478.00;
		items[11].height = 514.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardRio2Layout_outlines5.call(items[12] as IPostcardRio2Layout_outlines5);
		items[12].x = 87.95;
		items[12].y = -144.4;
		items[12].width = 478.00;
		items[12].height = 511.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardRio2Layout_outlines6.call(items[13] as IPostcardRio2Layout_outlines6);
		items[13].x = 479;
		items[13].y = -431.15;
		items[13].width = 256.00;
		items[13].height = 298.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	const shapes = this.shapes;
	if (!shapes[0] && shapes.elementFactory) {
		shapes[0] = shapes.elementFactory(0,undefined);
	}
	if (shapes[0]) {
		shapes[0] = [10.00,0.00];
	}
	if (!shapes[1] && shapes.elementFactory) {
		shapes[1] = shapes.elementFactory(1,undefined);
	}
	if (shapes[1]) {
		shapes[1] = [15.00,0.00];
	}
	if (!shapes[2] && shapes.elementFactory) {
		shapes[2] = shapes.elementFactory(2,undefined);
	}
	if (shapes[2]) {
		shapes[2] = [15.00,0.00];
	}
	if (!shapes[3] && shapes.elementFactory) {
		shapes[3] = shapes.elementFactory(3,undefined);
	}
	if (shapes[3]) {
		shapes[3] = [15.00,0.00];
	}
	if (!shapes[4] && shapes.elementFactory) {
		shapes[4] = shapes.elementFactory(4,undefined);
	}
	if (shapes[4]) {
		shapes[4] = [146.55,119.00,165.45,33.95,306.05,-11.90,348.15,-326.60,315.85,-400.60,259.15,-428.95,168.60,-425.05,68.65,-335.30,11.95,-299.05,-42.40,-295.90,-101.45,-262.05,-139.20,-205.35,-166.75,-103.00,-155.75,-67.60,-89.60,-31.35,-15.60,20.60,22.95,120.55];
	}
	if (!shapes[5] && shapes.elementFactory) {
		shapes[5] = shapes.elementFactory(5,undefined);
	}
	if (shapes[5]) {
		shapes[5] = [10.00,0.00];
	}
	if (!shapes[6] && shapes.elementFactory) {
		shapes[6] = shapes.elementFactory(6,undefined);
	}
	if (shapes[6]) {
		shapes[6] = [84.50,-467.55,350.30,-198.65,376.30,-71.85,414.45,3.00,542.85,68.65,629.90,380.30,295.35,426.15,-16.30,456.70,-208.80,468.90,-473.05,445.95,-641.10,407.75,-648.75,68.65,-486.80,53.40,-427.25,-10.75,-279.05,-18.40,-253.10,-169.65,-162.95,-210.90,-123.25,-331.55,-17.80,-352.95,31.05,-467.55];
	}
	const background = this.background;
	PostcardRio2Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardRio2Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardRio2Layout_background(this: IPostcardRio2Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-rio-2.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform7(this: IPostcardRio2Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-7.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform2(this: IPostcardRio2Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-2.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform1(this: IPostcardRio2Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-1.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform5(this: IPostcardRio2Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-5.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform8(this: IPostcardRio2Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-8.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform4(this: IPostcardRio2Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-4.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform3(this: IPostcardRio2Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-3.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_cardTransform6(this: IPostcardRio2Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-2-6.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_pieces7(this: IPostcardRio2Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardRio2Layout_outlines7(this: IPostcardRio2Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardRio2Layout_pieces4(this: IPostcardRio2Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-2-4.png", 0.502, 0.500);
	return this;
}
function PostcardRio2Layout_outlines4(this: IPostcardRio2Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-2-4.png", 0.502, 0.500);
	return this;
}
function PostcardRio2Layout_pieces3(this: IPostcardRio2Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-2-3.png", 0.502, 0.500);
	return this;
}
function PostcardRio2Layout_outlines3(this: IPostcardRio2Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-2-3.png", 0.502, 0.501);
	return this;
}
function PostcardRio2Layout_pieces2(this: IPostcardRio2Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-2-2.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_outlines2(this: IPostcardRio2Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-2-2.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_pieces1(this: IPostcardRio2Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-2-1.png", 0.501, 0.501);
	return this;
}
function PostcardRio2Layout_outlines1(this: IPostcardRio2Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-2-1.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_pieces6(this: IPostcardRio2Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-2-6.png", 0.500, 0.502);
	return this;
}
function PostcardRio2Layout_pieces5(this: IPostcardRio2Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-2-5.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_outlines5(this: IPostcardRio2Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardRio2Layout_outlines6(this: IPostcardRio2Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-2-6.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_shapes7(this: IPostcardRio2Layout_shapes7) {
	return this;
}
function PostcardRio2Layout_shapes1(this: IPostcardRio2Layout_shapes1) {
	return this;
}
function PostcardRio2Layout_shapes2(this: IPostcardRio2Layout_shapes2) {
	return this;
}
function PostcardRio2Layout_shapes3(this: IPostcardRio2Layout_shapes3) {
	return this;
}
function PostcardRio2Layout_shapes4(this: IPostcardRio2Layout_shapes4) {
	return this;
}
function PostcardRio2Layout_shapes5(this: IPostcardRio2Layout_shapes5) {
	return this;
}
function PostcardRio2Layout_shapes6(this: IPostcardRio2Layout_shapes6) {
	return this;
}
function PostcardRio2Layout_postcardOverlay(this: IPostcardRio2Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardRio2Layout_postcardMask(this: IPostcardRio2Layout_postcardMask) {
	return this;
}
interface IPostcardRio2LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardRio2LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardRio2LayoutSprite extends IPostcardRio2LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardRio2LayoutText extends IPostcardRio2LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardRio2LayoutPolygon extends Array<number> {
}
interface IPostcardRio2Layout {
	readonly main: IPostcardRio2Layout_main;
}
interface IPostcardRio2Layout_main extends IPostcardRio2LayoutContainer {
	readonly postcard: IPostcardRio2Layout_postcard;
}
interface IPostcardRio2Layout_postcard extends IPostcardRio2LayoutContainer {
	readonly cardTransform: IPostcardRio2LayoutArray<IPostcardRio2Layout_cardTransform1|IPostcardRio2Layout_cardTransform2|IPostcardRio2Layout_cardTransform3|IPostcardRio2Layout_cardTransform4|IPostcardRio2Layout_cardTransform5|IPostcardRio2Layout_cardTransform6|IPostcardRio2Layout_cardTransform7|IPostcardRio2Layout_cardTransform8>;
	readonly items: IPostcardRio2LayoutArray<IPostcardRio2Layout_pieces7|IPostcardRio2Layout_outlines7|IPostcardRio2Layout_pieces4|IPostcardRio2Layout_outlines4|IPostcardRio2Layout_pieces3|IPostcardRio2Layout_outlines3|IPostcardRio2Layout_pieces2|IPostcardRio2Layout_outlines2|IPostcardRio2Layout_pieces1|IPostcardRio2Layout_outlines1|IPostcardRio2Layout_pieces6|IPostcardRio2Layout_pieces5|IPostcardRio2Layout_outlines5|IPostcardRio2Layout_outlines6>;
	readonly shapes: IPostcardRio2LayoutArray<IPostcardRio2Layout_shapes1|IPostcardRio2Layout_shapes2|IPostcardRio2Layout_shapes3|IPostcardRio2Layout_shapes4|IPostcardRio2Layout_shapes5|IPostcardRio2Layout_shapes6|IPostcardRio2Layout_shapes7>;
	readonly background: IPostcardRio2Layout_background;
	readonly postcardOverlay: IPostcardRio2Layout_postcardOverlay;
	readonly postcardMask: IPostcardRio2Layout_postcardMask;
}
interface IPostcardRio2Layout_background extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform7 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform2 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform1 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform5 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform8 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform4 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform3 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_cardTransform6 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_pieces7 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_outlines7 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_pieces4 extends IPostcardRio2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio2Layout_outlines4 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_pieces3 extends IPostcardRio2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio2Layout_outlines3 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_pieces2 extends IPostcardRio2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio2Layout_outlines2 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_pieces1 extends IPostcardRio2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio2Layout_outlines1 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_pieces6 extends IPostcardRio2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio2Layout_pieces5 extends IPostcardRio2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio2Layout_outlines5 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_outlines6 extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_shapes7 extends IPostcardRio2LayoutPolygon {
}
interface IPostcardRio2Layout_shapes1 extends IPostcardRio2LayoutPolygon {
}
interface IPostcardRio2Layout_shapes2 extends IPostcardRio2LayoutPolygon {
}
interface IPostcardRio2Layout_shapes3 extends IPostcardRio2LayoutPolygon {
}
interface IPostcardRio2Layout_shapes4 extends IPostcardRio2LayoutPolygon {
}
interface IPostcardRio2Layout_shapes5 extends IPostcardRio2LayoutPolygon {
}
interface IPostcardRio2Layout_shapes6 extends IPostcardRio2LayoutPolygon {
}
interface IPostcardRio2Layout_postcardOverlay extends IPostcardRio2LayoutSprite {
}
interface IPostcardRio2Layout_postcardMask extends IPostcardRio2LayoutPolygon {
}
